import React from "react";
import PortableText from "./portableText";
import clientConfig from "../../client-config";
import * as styles from './videoModal.module.css';

function VideoModal(props) {

    let modalClass = styles.videoModal + ' video-modal ' + ((props.isOpen) ? styles.videoModalOpen : 'not-open');

    return(
        <div className={modalClass}>
            <div className={styles.modalBg} onClick={props.closeVideoModal}></div>
            <div className={styles.modalContentBox}>
                <div className={styles.iframeWrap}>
                    <div className={styles.modalClose} title="Close" onClick={props.closeVideoModal}>&times;</div>
                    <iframe width="1080" height="615" src={props.videoSrc} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                </div>
            </div>
        </div>
    );

}

export default VideoModal;